import PropTypes from 'prop-types';
import { forwardRef } from 'react';

// Hidden right drawer: return null to remove it from the UI.
const RightSideDrawer = forwardRef(() => null);

RightSideDrawer.propTypes = {
  workflowId: PropTypes.string,
  clearSourceSelection: PropTypes.number,
  collapsedBoth: PropTypes.bool,
  onCollapsedChange: PropTypes.func,
};

RightSideDrawer.displayName = 'RightSideDrawer';

export default RightSideDrawer;
